import React from 'react';
import { NavigationNodeId } from '@pwc/pwc-deals-web-common';
import { useTranslation } from 'react-i18next';
import CreateHypothesisLinkButton from '../CreateHypothesisLinkButton';
import EmptyContentCard from '../../../common/components/EmptyContentCard/EmptyContentCard';
import { getNavigationTitle } from '../../../common/helpers/getCustomNavigationTitles';
import { useKFATitleI18n } from '../../../common/hooks/useKFATitleI18n';

const EmptyHypothesesCard = ({ projectId }) => {
  const hypothesesTitle = getNavigationTitle(NavigationNodeId.KEY_FOCUS_AREAS);
  const kfaTitlei18n = useKFATitleI18n(hypothesesTitle);
  const { t } = useTranslation();

  return (
    <EmptyContentCard projectId={projectId} name={kfaTitlei18n}>
      <CreateHypothesisLinkButton
        projectId={projectId}
        data-testid="empty-hypotheses-card-create-button"
        buttonTitle={`${t('btn.create')} ${t(kfaTitlei18n)}`}
      />
    </EmptyContentCard>
  );
};

export default EmptyHypothesesCard;
